import shallowEqual from 'shallowequal';
export default shallowEqual;


//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/dist/es/lib/shallowEqual.js
// module id = 2856
// module chunks = 0